import { NOTIFICATION_LIST } from "./types";

export const notificationList = (data, onSuccess, onError) => {
  return {
    type: NOTIFICATION_LIST,
    data,
    onSuccess,
    onError,
  };
};
